(function () {
  // La Belle Maison — Material swatch selector for mural PDPs.
  // Only runs on product pages that carry the Extendons wall-size calculator
  // (#eo-sh-length), i.e. Murals — Roll Wallpaper products don't have it and
  // are intentionally skipped. Adds a "properties[Material]" hidden input to
  // the native cart-add form so the chosen material rides along as a
  // line-item property, without touching Shopify variants/options (which are
  // already fully owned by the Extendons per-sqm calculator on these products).
  if (window.location.pathname.indexOf('/products/') === -1) return;

  var MATERIALS = [
    { key: 'Non Woven', img: 'https://cdn.shopify.com/s/files/1/0521/1665/2227/files/01_Non-Woven.png?v=1789312591' },
    { key: 'Petra', img: 'https://cdn.shopify.com/s/files/1/0521/1665/2227/files/02_Petra.png?v=1789312591' },
    { key: 'Self Adhesive', img: 'https://cdn.shopify.com/s/files/1/0521/1665/2227/files/04_Self_Adhesive.png?v=1789312591' },
    { key: 'Sand', img: 'https://cdn.shopify.com/s/files/1/0521/1665/2227/files/05_Sand.png?v=1789312591' },
    { key: 'Textile', img: 'https://cdn.shopify.com/s/files/1/0521/1665/2227/files/07_Textile.png?v=1789312591' },
    { key: 'Jute', img: 'https://cdn.shopify.com/s/files/1/0521/1665/2227/files/08_Jute.png?v=1789312591' },
    { key: 'Commercial', img: 'https://cdn.shopify.com/s/files/1/0521/1665/2227/files/12_Commercial.png?v=1789312591' },
    { key: 'Bella', img: 'https://cdn.shopify.com/s/files/1/0521/1665/2227/files/16_Bella.png?v=1789312591' }
  ];
  var DEFAULT_MATERIAL = 'Petra';
  var WRAP_ID = 'lbm-material-select';
  var STORAGE_KEY = 'lbm_selected_material';

  var CSS = [
    '#' + WRAP_ID + '{margin:0 0 18px;}',
    '#' + WRAP_ID + ' .lbm-mat-label{display:flex;align-items:center;justify-content:space-between;margin:0 0 10px;}',
    '#' + WRAP_ID + ' .lbm-mat-label span:first-child{font-size:12px;letter-spacing:.08em;text-transform:uppercase;color:#2B241C;font-weight:600;}',
    '#' + WRAP_ID + ' .lbm-mat-selected{font-size:12.5px;color:#8c7b6a;}',
    '#' + WRAP_ID + ' .lbm-mat-link{font-size:11.5px;color:#8c7b6a;text-decoration:underline;text-underline-offset:2px;}',
    '#' + WRAP_ID + ' .lbm-mat-swatches{display:flex;flex-wrap:wrap;gap:8px;}',
    '#' + WRAP_ID + ' .lbm-mat-swatch{width:52px;height:52px;border-radius:50%;overflow:hidden;border:2px solid transparent;padding:0;cursor:pointer;background:#eee;position:relative;flex-shrink:0;transition:border-color .15s;}',
    '#' + WRAP_ID + ' .lbm-mat-swatch img{width:100%;height:100%;object-fit:cover;display:block;border-radius:50%;}',
    '#' + WRAP_ID + ' .lbm-mat-swatch.is-selected{border-color:#232E4A;}',
    '#' + WRAP_ID + ' .lbm-mat-swatch:focus-visible{outline:2px solid #232E4A;outline-offset:2px;}',
    '#' + WRAP_ID + ' .lbm-mat-swatch.is-selected::after{content:"";position:absolute;inset:0;border-radius:50%;box-shadow:0 0 0 1px #fff inset;}'
  ].join('\n');

  function ensureCss() {
    if (document.getElementById(WRAP_ID + '-css')) return;
    var s = document.createElement('style');
    s.id = WRAP_ID + '-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function getSavedMaterial() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) || DEFAULT_MATERIAL;
    } catch (e) {
      return DEFAULT_MATERIAL;
    }
  }

  function saveMaterial(key) {
    try { window.localStorage.setItem(STORAGE_KEY, key); } catch (e) { /* ignore */ }
  }

  function buildWidget() {
    var wrap = document.createElement('div');
    wrap.id = WRAP_ID;

    var label = document.createElement('div');
    label.className = 'lbm-mat-label';
    var left = document.createElement('span');
    left.textContent = 'Material';
    var selectedText = document.createElement('span');
    selectedText.className = 'lbm-mat-selected';
    label.appendChild(left);
    label.appendChild(selectedText);
    wrap.appendChild(label);

    var row = document.createElement('div');
    row.className = 'lbm-mat-swatches';
    wrap.appendChild(row);

    var linkP = document.createElement('p');
    linkP.style.margin = '10px 0 0';
    var link = document.createElement('a');
    link.href = '/pages/materials';
    link.className = 'lbm-mat-link';
    link.textContent = 'Compare our 8 materials';
    linkP.appendChild(link);
    wrap.appendChild(linkP);

    var current = getSavedMaterial();

    MATERIALS.forEach(function (m) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lbm-mat-swatch' + (m.key === current ? ' is-selected' : '');
      btn.setAttribute('data-material', m.key);
      btn.setAttribute('aria-label', m.key);
      btn.title = m.key;
      var img = document.createElement('img');
      img.src = m.img + '&width=104';
      img.alt = m.key + ' material swatch';
      img.loading = 'lazy';
      btn.appendChild(img);
      row.appendChild(btn);
    });

    selectedText.textContent = current;

    row.addEventListener('click', function (e) {
      var btn = e.target.closest('.lbm-mat-swatch');
      if (!btn) return;
      var key = btn.getAttribute('data-material');
      row.querySelectorAll('.lbm-mat-swatch').forEach(function (b) {
        b.classList.toggle('is-selected', b === btn);
      });
      selectedText.textContent = key;
      saveMaterial(key);
      syncHiddenInput(key);
    });

    return wrap;
  }

  function syncHiddenInput(materialKey) {
    var forms = document.querySelectorAll('form[action^="/cart/add"]');
    forms.forEach(function (form) {
      var input = form.querySelector('input[name="properties[Material]"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[Material]';
        form.appendChild(input);
      }
      input.value = materialKey;
    });
  }

  function init() {
    if (document.getElementById(WRAP_ID)) return true;
    var lengthInput = document.getElementById('eo-sh-length');
    if (!lengthInput) return false; // not a mural/calculator product — skip (e.g. Roll Wallpaper)

    ensureCss();
    var widget = buildWidget();

    // Prefer inserting right above the wall-size calculator's price anchor
    // (#lbm-pdp-price-anchor, added by an earlier script) so the flow reads
    // Material -> Dimensions -> Price -> Add to Cart. Fall back to just above
    // the calculator form itself.
    var anchor = document.getElementById('lbm-pdp-price-anchor');
    var calcForm = lengthInput.closest('form') || lengthInput.parentNode;
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(widget, anchor);
    } else if (calcForm && calcForm.parentNode) {
      calcForm.parentNode.insertBefore(widget, calcForm);
    } else {
      return false;
    }

    syncHiddenInput(getSavedMaterial());
    return true;
  }

  if (!init()) {
    var attempts = 0;
    var timer = setInterval(function () {
      if (init() || ++attempts > 60) clearInterval(timer);
    }, 250);
  }
})();
